import { Card, Heading, Paragraph } from '@zillow/constellation-10';

import type React from 'react';
import type { CardRootPropsInterface } from '@zillow/constellation-10';
import type { PropsWithChildren, ReactElement } from 'react';

interface DataCardProps {
  heading: string | ReactElement;
  copyText: string | ReactElement;
  source?: string;
  useFullScreen: boolean;
  height?: number;
  addMarginTop?: boolean;
}

const DataCard: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<PropsWithChildren<DataCardProps & CardRootPropsInterface>>>
> = (props) => {
  const { heading, copyText, source, useFullScreen, height, addMarginTop, children, ...rest } = props;
  return (
    <Card
      tone="neutral"
      css={{
        position: 'relative',
        width: useFullScreen ? '100%' : 'calc(50% - {sizes.300})',
        display: 'flex',
        flexDirection: 'column',
        padding: '600',
        paddingBottom: source ? '1200' : '600',
        marginTop: addMarginTop ? '600' : undefined,
      }}
      style={{ height: height ? `${height}px` : undefined }}
      {...rest}
    >
      <Heading level={2} textStyle="heading-sm" fontFamily="heading-alt">
        {heading}
      </Heading>
      <Paragraph textStyle="body-sm" color="text.subtle" css={{ marginBottom: '600' }}>
        {copyText}
      </Paragraph>

      {children}
      {source && (
        <Paragraph textStyle="body-sm" color="text.subtle" css={{ position: 'absolute', bottom: '400' }}>
          Source: {source}
        </Paragraph>
      )}
    </Card>
  );
};

export default DataCard;
